class DragHorizontalScroll {
  constructor(DOMElement) {
    this.slider = typeof DOMElement === 'string' ? document.querySelector(DOMElement) : DOMElement
    this.mouseDown = false
    this.startX = 0
    this.scrollLeft = 0

    this.touchStartX = 0
    this.touchStartScrollLeft = 0

    this.slider.addEventListener('mousemove', this.move.bind(this), false)
    this.slider.addEventListener(
      'mousedown',
      this.startDragging.bind(this),
      false
    )
    this.slider.addEventListener('mouseup', this.stopDragging.bind(this), false)
    this.slider.addEventListener(
      'mouseleave',
      this.stopDragging.bind(this),
      false
    )

    this.slider.addEventListener(
      'touchstart',
      this.startTouchDragging.bind(this),
      false
    )
    this.slider.addEventListener(
      'touchend',
      this.stopTouchDragging.bind(this),
      false
    )
    this.slider.addEventListener('touchmove', this.moveTouch.bind(this), false)
  }

  startDragging(e) {
    this.mouseDown = true
    this.startX = e.pageX - this.slider.offsetLeft
    this.scrollLeft = this.slider.scrollLeft
    this.owner = this.slider.closest('product-customizer');
    this.startPhase = this.owner?._repeatPhase || 0;
  }

  stopDragging(e) {
    this.mouseDown = false
  }

  move(e) {
    e.preventDefault()
    if (!this.mouseDown) return
    const x = e.pageX - this.slider.offsetLeft
    const scroll = x - this.startX
    if (this.owner?.isReplicated) {
      this.owner.setRepeatPhase(this.startPhase - (this.owner.flip ? -1 : 1) * scroll / (this.owner.scale || 1) / this.owner._repeatProjectionHeight);
      return;
    }
    this.slider.scrollLeft = this.scrollLeft - scroll

    // Save the current scroll position to localStorage
    localStorage.setItem('sliderScrollPosition', this.slider.scrollLeft)
  }

  startTouchDragging(e) {
    this.touchStartX = e.touches[0].pageX - this.slider.offsetLeft
    this.touchStartScrollLeft = this.slider.scrollLeft
    this.owner = this.slider.closest('product-customizer');
    this.startPhase = this.owner?._repeatPhase || 0;
  }

  stopTouchDragging(e) {
    // No action needed for touch end
  }

  moveTouch(e) {
    e.preventDefault()
    const touchX = e.touches[0].pageX - this.slider.offsetLeft
    const touchScroll = touchX - this.touchStartX
    if (this.owner?.isReplicated) {
      this.owner.setRepeatPhase(this.startPhase - (this.owner.flip ? -1 : 1) * touchScroll / (this.owner.scale || 1) / this.owner._repeatProjectionHeight);
      return;
    }
    this.slider.scrollLeft = this.touchStartScrollLeft - touchScroll

    // Save the current scroll position to localStorage
    localStorage.setItem('sliderScrollPosition', this.slider.scrollLeft)
  }
}

// PERF-PDF-LAZY-LOAD-START
let pdfLibraryPromise

function loadPdfLibrary() {
  if (window.jspdf?.jsPDF) {
    return Promise.resolve(window.jspdf.jsPDF)
  }

  if (pdfLibraryPromise) {
    return pdfLibraryPromise
  }

  const assetUrl = window.customizer?.jsPdfUrl
  if (!assetUrl) {
    return Promise.reject(new Error('Missing jsPDF asset URL'))
  }

  pdfLibraryPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = assetUrl
    script.async = true
    script.dataset.matchwallsPdfLibrary = 'true'

    const rejectAndAllowRetry = (error) => {
      pdfLibraryPromise = undefined
      reject(error)
    }

    script.addEventListener('load', () => {
      if (window.jspdf?.jsPDF) {
        resolve(window.jspdf.jsPDF)
      } else {
        rejectAndAllowRetry(new Error('jsPDF loaded without exposing its API'))
      }
    }, { once: true })
    script.addEventListener('error', () => {
      rejectAndAllowRetry(new Error('Unable to load jsPDF'))
    }, { once: true })

    document.head.appendChild(script)
  })

  return pdfLibraryPromise
}
// PERF-PDF-LAZY-LOAD-END



class CustomizerDialog extends HTMLElement {
  constructor() {
    super()
    this.currentPrice = null
    this.currentPriceCompare = null
    this.currentVariant = null
    this.measure = ''
    this.dimensions = 0

    this.width = 0
    this.height = 0

    // All measures have 1m as base unit
    this.surface = {
      m: 1,
      ft: 10.764,
      cm: 10000,
      in: 1550
    }

    this.elems = {
      form: null,
      dialogElem: null,
      cancelButtons: null,
      openButton: null,
      quantityInput: null,
      radioInputs: null,
      numberInputs: null,
      price: null,
      dimensions: null,
      idInput: null,
      rolls: null
    }

    this.totalQuantity = 0
    this.elems.rolls = null
  }

  connectedCallback() {
    // Variables
    const surface = Number(this.getAttribute('data-surface'))
    console.log(surface)
    if (surface) {
      this.surface.m = surface
      this.surface.ft = surface * 10.764
      this.surface.cm = surface * 10000
      this.surface.in = surface * 1550
    }
    this.elems.length = this.querySelector('button[data-action="length"]')
    this.elems.lengthLinesElem = this.querySelector('.length-lines')
    this.elems.form = this.querySelector('form')
    this.elems.idInput = this.querySelector('input[name=id]')
    this.elems.dialogElem = this.querySelector('dialog')
    this.elems.openButton = this.querySelector('[open-modal]')
    this.elems.cancelButtons = this.querySelectorAll('[close-modal]')
    this.elems.numberInputs = this.querySelectorAll('input[type=number]')
    this.elems.radioInputs = this.querySelectorAll('input[type=radio]')
    this.elems.quantityInput = this.querySelector('input[name=quantity]')
    this.elems.price = this.querySelector('.final-price')
    this.elems.priceCompare = this.querySelector('.compare-final-price')
    this.elems.dimensions = this.querySelector('.total-surface')
    this.elems.rolls = this.querySelector('.rolls-quantity')
    this.pdfButton = document.querySelector('#downloadpdf');
    if (this.pdfButton) {
      window.addEventListener('load', () => {
        this.pdfButton.addEventListener('click', this.generatePDF.bind(this));
      });
    }
    // Listeners
    this.elems.openButton.addEventListener('click', this.openDialog.bind(this))
    this.elems.cancelButtons.forEach((elem) => {
      elem.addEventListener('click', this.closeDialog.bind(this))
    })
    this.elems.numberInputs.forEach((input) => {
      input.addEventListener('input', this.onInputNumberChange.bind(this))
    })
    this.elems.radioInputs.forEach((input) => {
      if (input.checked) this.measure = input.value
      input.addEventListener('change', this.onRadioChange.bind(this))
    })
    this.elems.form.addEventListener('submit', this.closeDialog.bind(this))
    this.extendSetup()
    this.update()
  }
  openDialog() {
    this.elems.dialogElem.showModal()
    this.update()
  }

  closeDialog() {
    this.elems.dialogElem.close()
  }

  onInputNumberChange(e) {
    const max = Number(e.target.max)
    const min = Number(e.target.min)
    const val = Number(e.target.value)

    if (val > max) {
      e.target.value = max
    } else if (val < min) {
      // e.target.value = min
    }
    this.update()
  }

  onRadioChange(e) {
    const unitSpans = document.querySelectorAll('.unit-form-control');
    console.log("this.meaure: ", this.measure)
    const newUnit = this.measure === 'ft' ? window.unitsTranslations.meter : window.unitsTranslations.feet;
    unitSpans.forEach(span => {
      span.textContent = newUnit;
    });
    this.measure = e.target.value
    this.update()
  }

  update() {
    this.updateValues()
    this.updateUI()
  }

  // This method is empty but required. The idea is that each child class can extend elements not present in the current constructor on the connectedCallback without modifying it.
  extendSetup() { }

  updateValues() {
    this.width = Number(this.elems.numberInputs[0].value)
    this.height = Number(this.elems.numberInputs[1].value)

    this.dimensions = Math.round(this.height * this.width * 100) / 100
    this.totalQuantity = Math.ceil(this.dimensions / this.surface[this.measure])
    this.elems.quantityInput.value = this.totalQuantity

    const id = document.querySelector(
      'input[name="id"]:not([customizer-input])'
    ).value

    document.querySelector(
      'input[name="quantity"]:not([customizer-input])'
    ).value = this.totalQuantity

    this.elems.idInput.value = id
    this.currentPrice = window.product.variants.find(
      (variant) => variant.id == id
    ).price
    this.currentPriceCompare = window.product.variants.find(
      (variant) => variant.id == id
    ).compare_at_price
  }
  updateUI() {
    const totalPrice = this.totalQuantity * (this.currentPrice / 100)
    console.log(" total Price: ", totalPrice)
    const currencySymbol = `${window.Shopify.currency.active} `
    console.log("window.Shopify.currency.active: ", window.Shopify)

    this.elems.dimensions.textContent = this.dimensions + this.measure
    this.elems.rolls.textContent = this.totalQuantity
    this.elems.price.textContent = `${currencySymbol}${totalPrice.toFixed(2)}`
    const totalPriceCompare = this.totalQuantity * (this.currentPriceCompare / 100)
    this.elems.priceCompare.textContent = `${currencySymbol}${totalPriceCompare.toFixed(2)}`;
    // Calculate the percentage discount and round it to the nearest whole number
    let discountPercentage = 0;
    if (totalPriceCompare > totalPrice) {
      discountPercentage = Math.round(((totalPriceCompare - totalPrice) / totalPriceCompare) * 100);
    }

    // Display the discount percentage if there's any discount
    if (discountPercentage > 0) {
      const discountElement = document.querySelector(".discount-percentage");
      discountElement.textContent = `-${discountPercentage}% `;
    }
    console.log("totalPriceCompare: ", totalPriceCompare)
  }
  async generatePDF() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'stimulation_download'
    });
    console.log("window.product: ", window.product);
    console.log("this.elemes.form: ", this.elems.form);

    const variantIdInput = this.elems.form.querySelector('input[name="id"]').value;
    console.log("here is the variant Input: ", variantIdInput);

    const productVariants = window.product.variants;
    console.log("productVariants: ", productVariants);

    const selectedVariant = productVariants.find(variant => variant.id == variantIdInput);

    if (selectedVariant) {
      console.log("Selected Variant Title: ", selectedVariant.title);
    } else {
      console.error("Variant not found for ID:", variantIdInput);
    }

    // Show spinner and overlay before PDF generation starts
    document.getElementById('loadingSpinner').style.display = 'block';
    document.getElementById('spinnerOverlay').style.display = 'block';

    console.log('generatePDF called!');

    let jsPDF
    try {
      jsPDF = await loadPdfLibrary()
    } catch (error) {
      console.error('Error loading PDF library:', error)
      document.getElementById('loadingSpinner').style.display = 'none'
      document.getElementById('spinnerOverlay').style.display = 'none'
      return
    }

    const doc = new jsPDF();

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const titleProduct = document.querySelector("#product-title");
    const title = titleProduct ? titleProduct.innerHTML.trim() : "Title not found";

    const skProduct = document.querySelector("#product-sku");
    const sku = skProduct ? skProduct.innerHTML.trim() : "SKU not found";

    const quaProduct = document.querySelector(".variant-picker__option button span");
    const quality = selectedVariant.title;

    const finalPrice = document.querySelector(".customizer__body .final-price").textContent;
    const currencySymbol = "EUR"; // Change this if needed

    const widthCm = this.width || 0;
    const heightCm = this.height || 0;
    const widthInch = (widthCm * 0.393701).toFixed(2);
    const heightInch = (heightCm * 0.393701).toFixed(2);
    const surfaceM2 = (widthCm * heightCm / 10000).toFixed(2);
    const surfaceFt2 = (surfaceM2 * 10.7639).toFixed(2);

    const textTitle = `Producto: ${title} | Referencia: ${sku}`;
    const textQuality = `Calidad del papel: ${quality}`;

    const textPrice = `Precio: ${finalPrice}`;
    const dimensionsText = `Medidas: ${widthCm} cm x ${heightCm} cm (${surfaceM2} m²) | ${widthInch} in x ${heightInch} in (${surfaceFt2} ft²)`;
    const surfaceText = `${surfaceM2} m² - ${surfaceFt2} ft²`;

    this.captureFrameImage().then((blob) => {
      const reader = new FileReader();

      reader.onload = function (event) {
        const imgData = event.target.result;

        const imageSectionHeight = pageHeight * 0.40;
        const maxImgHeight = imageSectionHeight * 0.70;
        const imgProps = doc.getImageProperties(imgData);
        let imgWidth = pageWidth * 0.9;
        let imgHeight = (imgProps.height * imgWidth) / imgProps.width;
        let imgXPosition = (pageWidth - imgWidth) / 2;

        if (imgHeight > maxImgHeight) {
          imgHeight = maxImgHeight;
          imgWidth = (imgProps.width * imgHeight) / imgProps.height;
          imgXPosition = (pageWidth - imgWidth) / 2;
        }
        const imgYPosition = 20;

        doc.setFontSize(14);
        doc.setTextColor(0, 0, 0);
        doc.text(surfaceText, pageWidth / 2, imgYPosition - 5, { align: 'center' });

        const adjustedImgYPosition = imgYPosition + 5;

        doc.addImage(imgData, 'PNG', imgXPosition, adjustedImgYPosition, imgWidth, imgHeight);

        doc.setLineWidth(0.5);
        const marginHeight = -20;
        const margin = 0;
        doc.line(imgXPosition - 4, adjustedImgYPosition, imgXPosition - 4, adjustedImgYPosition + imgHeight);
        doc.line(imgXPosition + imgWidth, adjustedImgYPosition, imgXPosition + imgWidth, adjustedImgYPosition + imgHeight);
        doc.line(imgXPosition, adjustedImgYPosition + 4 + imgHeight, imgXPosition + imgWidth, adjustedImgYPosition + imgHeight + 4);

        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        doc.text(`${heightCm} cm / ${heightInch} in`, imgXPosition - marginHeight, adjustedImgYPosition + (imgHeight / 2), { align: 'right', angle: 90 });
        doc.text(`${widthCm} cm / ${widthInch} in`, imgXPosition + imgWidth / 2, adjustedImgYPosition + imgHeight + margin + 10, { align: 'center' });

        const productInfoYPosition = adjustedImgYPosition + imgHeight + 20;
        doc.text(textTitle, 10, productInfoYPosition);
        doc.text(textQuality, 10, productInfoYPosition + 10);
        doc.text(dimensionsText, 10, productInfoYPosition + 20);
        doc.text(textPrice, 10, productInfoYPosition + 30);

        const legalInfoYPosition = productInfoYPosition + 50;
        const legalOne = window.customizer.legalone || "Legal text 1 not found";
        const legalTwo = window.customizer.legaltwo || "Legal text 2 not found";
        const legalTwoLines = doc.splitTextToSize(legalTwo, pageWidth - 20);
        const legalOneLines = doc.splitTextToSize(legalOne, pageWidth - 20);

        doc.setTextColor(0, 0, 0);
        doc.text(legalOneLines, 10, legalInfoYPosition, { maxWidth: pageWidth - 20 });
        doc.text(legalTwoLines, 10, legalInfoYPosition + 20, { maxWidth: pageWidth - 20 });

        // Select the logo from the DOM using querySelector
        const logoElement = document.querySelector('.header__logo-image');
        if (logoElement) {
          const logoSrc = logoElement.getAttribute('src');

          // Convert SVG to PNG using a canvas element
          const logoImg = new Image();
          logoImg.src = logoSrc;
          logoImg.onload = function () {
            const canvas = document.createElement('canvas');
            canvas.width = logoImg.width;
            canvas.height = logoImg.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(logoImg, 0, 0);
            const logoDataUrl = canvas.toDataURL('image/png');  // Convert to PNG format

            const footerImageHeight = 15;  // Adjust as needed
            const footerImageYPosition = pageHeight - footerImageHeight - 10;  // 10 units margin from the bottom
            const logoWidth = (logoImg.width / logoImg.height) * footerImageHeight; // Maintain aspect ratio

            doc.addImage(logoDataUrl, 'PNG', (pageWidth - logoWidth) / 2, footerImageYPosition, logoWidth, footerImageHeight);
            doc.save("customizer-summary.pdf");

            // Hide spinner and overlay after PDF is saved
            document.getElementById('loadingSpinner').style.display = 'none';
            document.getElementById('spinnerOverlay').style.display = 'none';
          };
        } else {
          console.error('Logo image not found');
        }
      };

      reader.readAsDataURL(blob);
    }).catch(error => {
      console.error('Error capturing frame image:', error);

      // Hide spinner and overlay in case of error
      document.getElementById('loadingSpinner').style.display = 'none';
      document.getElementById('spinnerOverlay').style.display = 'none';
    });
  }












}

customElements.define('rolls-calculator', CustomizerDialog)

class ProductCustomizer extends CustomizerDialog {
  constructor() {
    super();
    this.isReplicated = this.getAttribute('replicate-product') === 'true';
    this.pixels = {
      cm: 37.795275591, // 1 cm to pixels
      in: 96,          // 1 inch to pixels
      feet: 1152       // 1 foot to pixels (96 * 12)
    };
    this.maxWidth = 0;
    this.maxHeight = 0;
    this.imageHeight = 410;
    this.greyScale = false;
    this.flip = false;
    this.verticalLines = false;
    this.widthInfo = this.querySelector('.canvas__width span');
    this.heightInfo = this.querySelector('.canvas__height span');
    this.canvasContainer = this.querySelector('.canvas__container');
    this.canvasProductImage = this.querySelector('.canvas_product_image'); // Image to zoom
    this.selectionFrame = this.querySelector('.selection-frame'); // Reference to the selection frame
    this.scale = 1; // Initialize the scale for zooming
    this._dragFrame = null;
    this._frameDragCleanup = null;
    this._resizeHandler = () => requestAnimationFrame(() => { this.calculateMaxSizes(); if(this.height>0&&this.width>0)this.updateFrameSize(this.height,this.width); });
    this._dragHorizontalScroll = null;
    this.variantForm = null;
    this._sourceVariantPicker = null;
    this._sourceVariantPickerDisplay = '';
    this._variantPickerClone = null;
    this._variantChangeHandler = () => {
      if (this._syncProductSelection()) this.updateUI();
      queueMicrotask(() => this.syncVariantPickerClone());
    };
    this._dialogBackdropHandler = (event) => {
      if (event.target === this.elems.dialogElem) this.closeDialog();
    };

    this.elems.greyScale = this.querySelector('button[data-action="grayscale"]');
    this.elems.flip = this.querySelector('button[data-action="flip"]');
    this.elems.length = this.querySelector('button[data-action="length"]');
    this.elems.lengthLinesElem = this.querySelector('.length-lines');
    this.elems.zoomInButton = this.querySelector('#zoom-in');
    this.elems.zoomOutButton = this.querySelector('#zoom-out');

    this.dimensionsInput = this.querySelector(
      'input[name="properties[dimensions]"]'
    );
    this.greyscaleInput = this.querySelector(
      'input[name="properties[greyscale]"]'
    );
    this.customizerInput = this.querySelector(
      'input[name="properties[_customizer]"]'
    );

    this.elems.greyScale.addEventListener(
      'click',
      this.greyScaleImage.bind(this)
    );
    this.elems.flip.addEventListener('click', this.flipImage.bind(this));
    this.elems.length.addEventListener('click', this.showLengths.bind(this));
    this.elems.zoomInButton.addEventListener('click', this.zoomIn.bind(this));
    this.elems.zoomOutButton.addEventListener('click', this.zoomOut.bind(this));
  }

  connectedCallback() {
    const surface = Number(this.getAttribute('data-surface'));
    if (surface) {
      this.surface.m = surface;
      this.surface.ft = surface * 10.764;
      this.surface.cm = surface * 10000;
      this.surface.in = surface * 1550;
    }
    this.elems.form = this.querySelector('form');
    this.elems.idInput = this.querySelector('input[name=id]');
    this.variantForm = document.forms.namedItem(this.getAttribute('variant-form'));
    this.elems.dialogElem = this.querySelector('dialog');
    this.elems.openButton = this.querySelector('[open-modal]');
    this.elems.cancelButtons = this.querySelectorAll('[close-modal]');
    this.elems.numberInputs = this.querySelectorAll('input[type=number]');
    this.elems.radioInputs = this.querySelectorAll('input[type=radio]');
    this.elems.quantityInput = this.querySelector('input[name=quantity]');
    this.elems.price = this.querySelector('.final-price');
    this.elems.buyButton = this.querySelector("#mural_cta")
    this.elems.buyButtonText = this.querySelector("#final-price-cta")
    this.elems.priceCompare = this.querySelector('.compare-final-price');
    this.elems.dimensions = this.querySelector('.total-surface');
    this.elems.rolls = this.querySelector('.rolls-quantity');
    this.elems.cminputs = this.querySelector(".form-surface");
    this.elems.ininputs = this.querySelector(".form-surface-feets");

    // Listeners
    this.elems.openButton.addEventListener('click', this.openDialog.bind(this));
    this.elems.cancelButtons.forEach((elem) => {
      elem.addEventListener('click', this.closeDialog.bind(this));
    });
    this.elems.numberInputs.forEach((input) => {
      input.addEventListener('input', this.onInputNumberChange.bind(this));
    });
    this.elems.radioInputs.forEach((input) => {
      if (input.checked) this.measure = input.value;
      input.addEventListener('change', this.onRadioChange.bind(this));
    });
    
    this.variantForm?.addEventListener('variant:change', this._variantChangeHandler);
    this.elems.dialogElem.addEventListener('click', this._dialogBackdropHandler);
    this.pdfButton = this.querySelector('#downloadpdf');
    if (this.pdfButton) {
      this.pdfButton.addEventListener('click', this.generatePDF.bind(this));
    }
    this.extendSetup();
    this.update();
    if (typeof this.convertToInches === 'function') {
      this.convertToInches();
      this.unitConverter();
    }
    this.showLengths(false); // This will update the lengths without toggling the lines

  }

  openDialog() {
    this.cloneVariantPicker();
    super.openDialog();
  }

  closeDialog() {
    if (this.elems.dialogElem.open) super.closeDialog();
    this._removeVariantPickerClone();
  }

  cloneVariantPicker() {
    if (this._variantPickerClone?.isConnected) {
      this.syncVariantPickerClone();
      return this._variantPickerClone;
    }

    const formId = this.getAttribute('variant-form');
    const source = Array.from(document.querySelectorAll('variant-picker')).find(
      (picker) => picker.getAttribute('form') === formId
    );
    const target = this.querySelector('.customizer-quality-selector');
    if (!source || !target) return null;

    const pickerCopy = source.cloneNode(true);
    pickerCopy.querySelectorAll('script').forEach((script) => script.remove());
    pickerCopy.querySelectorAll('[data-mw-compare]').forEach((link) => link.remove());

    const clone = document.createElement('div');
    clone.className = pickerCopy.className;
    clone.dataset.matchwallsVariantPickerClone = 'true';
    clone.append(...pickerCopy.childNodes);

    const suffix = `--customizer-${formId.replace(/[^a-zA-Z0-9_-]/g, '-')}`;
    const idMap = new Map();
    clone.querySelectorAll('[id]').forEach((element) => {
      const previousId = element.id;
      const nextId = `${previousId}${suffix}`;
      idMap.set(previousId, nextId);
      element.id = nextId;
    });
    ['for', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'aria-owns'].forEach((attribute) => {
      clone.querySelectorAll(`[${attribute}]`).forEach((element) => {
        const nextValue = element.getAttribute(attribute)
          .split(/\s+/)
          .map((value) => idMap.get(value) ?? value)
          .join(' ');
        element.setAttribute(attribute, nextValue);
      });
    });
    clone.querySelectorAll('input[type="radio"]').forEach((input) => input.removeAttribute('form'));
    clone.querySelector('.variant-picker__option-info')?.style.setProperty('display', 'none');

    clone.addEventListener('change', (event) => {
      const cloneInput = event.target?.closest?.('input[type="radio"][name^="option"]');
      if (!cloneInput) return;

      const sourceInput = Array.from(source.querySelectorAll('input[type="radio"]')).find(
        (input) => input.name === cloneInput.name && input.value === cloneInput.value
      );
      if (!sourceInput) return;

      if (!sourceInput.checked) sourceInput.click();
      this._syncProductSelection();
      queueMicrotask(() => this.syncVariantPickerClone());
    });

    this._sourceVariantPicker = source;
    this._sourceVariantPickerDisplay = source.style.display;
    this._variantPickerClone = clone;
    source.style.display = 'none';
    target.replaceChildren(clone);
    this.syncVariantPickerClone();
    return clone;
  }

  syncVariantPickerClone() {
    if (!this._sourceVariantPicker || !this._variantPickerClone) return;

    this._variantPickerClone.querySelectorAll('input[type="radio"]').forEach((cloneInput) => {
      const sourceInput = Array.from(this._sourceVariantPicker.querySelectorAll('input[type="radio"]')).find(
        (input) => input.name === cloneInput.name && input.value === cloneInput.value
      );
      if (!sourceInput) return;

      cloneInput.checked = sourceInput.checked;
      cloneInput.disabled = sourceInput.disabled;
      const label = cloneInput.nextElementSibling;
      label?.classList.toggle('selected-variant', sourceInput.checked);
    });
  }

  _removeVariantPickerClone() {
    this._variantPickerClone?.remove();
    this._variantPickerClone = null;
    if (this._sourceVariantPicker) {
      this._sourceVariantPicker.style.display = this._sourceVariantPickerDisplay;
    }
    this._sourceVariantPicker = null;
    this._sourceVariantPickerDisplay = '';
  }

  _syncProductSelection() {
    const sourceIdInput = this.variantForm?.elements.namedItem('id');
    const sourceQuantityInput = this.variantForm?.elements.namedItem('quantity');
    if (!sourceIdInput) return false;

    const variant = window.product.variants.find(
      (productVariant) => String(productVariant.id) === String(sourceIdInput.value)
    );
    if (!variant) return false;

    if (sourceQuantityInput) sourceQuantityInput.value = this.totalQuantity;
    this.elems.idInput.value = sourceIdInput.value;
    this.currentPrice = variant.price;
    this.currentPriceCompare = variant.compare_at_price;
    return true;
  }

  extendSetup() {
    this.calculateMaxSizes();
    if (!this._dragHorizontalScroll) {
      this._dragHorizontalScroll = new DragHorizontalScroll(this.canvasContainer);
    }
    window.removeEventListener('resize', this._resizeHandler);
    window.addEventListener('resize', this._resizeHandler);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._resizeHandler);
    this.variantForm?.removeEventListener('variant:change', this._variantChangeHandler);
    this.elems?.dialogElem?.removeEventListener('click', this._dialogBackdropHandler);
    this._removeVariantPickerClone();
    this._frameDragCleanup?.();
  }

  async generatePDF() {
    if (this._pdfPending) return;
    const copy = window.MWMainHelpCopy?.[document.documentElement.lang] || window.MWMainHelpCopy?.en;
    const overlay = this.querySelector('#spinnerOverlay'), spinner = this.querySelector('#loadingSpinner');
    this._pdfPending = true;
    this.pdfButton.disabled = true;
    try {
      const displayLabels = {width:this.querySelector('.canvas__width span')?.textContent,height:this.querySelector('.canvas__height span')?.textContent};
      this.querySelector('[data-mw-pdf-error]')?.remove();
      if (!(this.width > 0 && this.height > 0 && this.currentPrice > 0)) throw new Error('Invalid configuration');
      if (overlay) overlay.style.display = 'block';
      if (spinner) spinner.style.display = 'block';
      const Constructor = await loadPdfLibrary();
      // Rasterize the original artwork again, not the screen-sized bitmap.
      const blob = await this.captureFrameImage(3);
      if (!blob || !blob.size) throw new Error('Empty image');
      const image = await new Promise((resolve, reject) => { const reader = new FileReader(); reader.onload = () => resolve(reader.result); reader.onerror = reject; reader.readAsDataURL(blob); });
      const pdf = new Constructor({unit:'mm',format:'a4'}), variant = window.product.variants.find(v => String(v.id) === String(this.elems.idInput.value));
      if (!variant) throw new Error('Unknown variant');
      const title = document.querySelector('.product-info h1')?.textContent.trim() || window.product.title;
      pdf.setFont('helvetica','normal');pdf.setFontSize(17);pdf.text(pdf.splitTextToSize(title,180),15,20);
      pdf.setFontSize(10);pdf.text('REF. '+(variant.sku || ''),15,35);
      const props = pdf.getImageProperties(image), box={width:170,height:130}, scale=Math.min(box.width/props.width,box.height/props.height), w=props.width*scale,h=props.height*scale,x=(210-w)/2,y=48;
      pdf.addImage(image,'PNG',x,y,w,h);
      const widthLabel = displayLabels.width || this.width+' cm', heightLabel = displayLabels.height || this.height+' cm';
      pdf.text(widthLabel,105,y+h+7,{align:'center'});pdf.text(heightLabel,x-5,y+h/2,{angle:90,align:'center'});
      let cursor=y+h+20;
      const displayNumber = new Intl.NumberFormat(document.documentElement.lang,{maximumFractionDigits:2,useGrouping:false});
      // Built-in Helvetica cannot encode the narrow/non-breaking grouping spaces
      // emitted by Intl in French. Normalize spacing only, never the quoted amount.
      const pdfMoneyText = this.elems.price.textContent.replace(/[\u00a0\u202f]/g,' ');
      for (const text of [copy.quality+': '+variant.title,copy.width+': '+displayNumber.format(this.width)+' cm · '+copy.height+': '+displayNumber.format(this.height)+' cm',copy.copies+': '+(this.querySelector('[name="properties[_mw_copies]"]')?.value || '1'),pdfMoneyText,copy.pdfNotice]) { const lines=pdf.splitTextToSize(text,180); if(cursor+lines.length*5>280){pdf.addPage();cursor=20;}pdf.text(lines,15,cursor);cursor+=lines.length*5+6; }
      pdf.save('matchwalls-simulation-'+(variant.sku || window.product.id)+'.pdf');
    } catch (error) {
      let message=this.querySelector('[data-mw-pdf-error]');if(!message){message=document.createElement('p');message.dataset.mwPdfError='';message.setAttribute('role','alert');this.querySelector('.customizer__content').append(message);}message.textContent=copy?.pdfError || 'Unable to generate PDF';
    } finally {
      if(overlay)overlay.style.display='none';if(spinner)spinner.style.display='none';this.pdfButton.disabled=false;this._pdfPending=false;document.dispatchEvent(new CustomEvent('mw:refresh-presentation'));
    }
  }

  updateValues() {

    if (this.measure === "cm") {
      this.width = Number(this.elems.numberInputs[0].value);
      this.height = Number(this.elems.numberInputs[1].value);

      this.dimensions = Math.round(this.height * this.width * 100) / 100;
      this.totalQuantity = Math.ceil(this.dimensions / this.surface[this.measure]);
      this.elems.quantityInput.value = this.totalQuantity;
      this._syncProductSelection();
    } else if (this.measure === "in") {
      const widthFeet = Number(this.elems.numberInputs[2].value);
      const widthInches = Number(this.elems.numberInputs[3].value);
      const heightFeet = Number(this.elems.numberInputs[4].value);
      const heightInches = Number(this.elems.numberInputs[5].value);

      const widthTotalInches = (widthFeet * 12) + widthInches;
      const heightTotalInches = (heightFeet * 12) + heightInches;

      this.width = widthTotalInches;
      this.height = heightTotalInches;

      this.dimensions = Math.round(this.height * this.width * 100) / 100;
      this.totalQuantity = Math.ceil(this.dimensions / this.surface[this.measure]);
      this.elems.quantityInput.value = this.totalQuantity;
      this._syncProductSelection();
    }
    this.updateFrameSize(this.height, this.width);
  }

  mwCommercialQuote() {
    try {
      const contract = JSON.parse(this.querySelector('[data-mw-market-contract]')?.textContent || 'null');
      const records = JSON.parse(this.querySelector('[data-mw-native-unit-rates]')?.textContent || '[]');
      const record = records.find(r => String(r.variantId) === String(this.elems.idInput.value));
      if (!contract?.valid || !record || record.productId !== Number(this.dataset.mwProductId) || record.country !== contract.country || record.currency !== contract.currency || record.marketId !== contract.market_id || record.marketGroup !== contract.market_group || record.sourceUnit !== contract.surface_unit || record.sourceId !== contract.version + '/' + contract.market_group || !(record.cents > 0)) return null;
      const factor = this.measure === 'in' ? 2.54 : this.measure === 'cm' ? 1 : NaN;
      const widthCm = Number(this.width) * factor, heightCm = Number(this.height) * factor;
      const copies = Number(this.elems.form.elements.namedItem('properties[_mw_copies]')?.value || 1);
      if (!(widthCm > 0 && heightCm > 0) || !Number.isFinite(widthCm + heightCm) || !Number.isSafeInteger(copies) || copies < 1) return null;
      const panels = Math.ceil(widthCm / 50), areaM2 = Math.max(3, panels * 0.5 * heightCm / 100);
      const area = record.sourceUnit === 'ft2' ? areaM2 / 0.09290304 : areaM2;
      const perCopyCents = Math.round((area * record.cents) + 1e-8), totalCents = perCopyCents * copies;
      if (!Number.isSafeInteger(totalCents)) return null;
      return {country:contract.country, marketGroup:contract.market_group, currency:contract.currency, sourceUnit:record.sourceUnit, rateCents:record.cents, panels, areaM2, copies, perCopyCents, totalCents};
    } catch { return null; }
  }

  updateUI() {
    this.dimensionsInput.value = `${this.elems.numberInputs[0].value}x${this.elems.numberInputs[1].value}${this.measure}`;

    const copies = Number(this.elems.form.elements.namedItem('properties[_mw_copies]')?.value || 1);
    const effectiveQuantity = this.totalQuantity * (Number.isSafeInteger(copies) && copies > 0 ? copies : 1);
    this.elems.quantityInput.value = effectiveQuantity;
    const sourceQuantity = this.variantForm?.elements.namedItem('quantity');
    if (sourceQuantity) sourceQuantity.value = effectiveQuantity;
    const totalPrice = effectiveQuantity * (this.currentPrice / 100);


    if (this.measure === 'cm') {
      this.elems.dimensions.textContent =
        (this.dimensions * 0.0001).toFixed(2) + 'm²';
    } else if (this.measure === 'in') {
      this.elems.dimensions.textContent =
        (this.dimensions * 0.00694444).toFixed(2) + 'ft²';
    }
    console.log("window.Shopify.currency.active: ", window.Shopify)
    const currencyCode = window.Shopify.currency.active;
    const currencySymbol = new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode })
      .formatToParts(1)
      .find(part => part.type === 'currency').value;

    console.log(currencySymbol); 

    const displayMoney = new Intl.NumberFormat(document.documentElement.lang, {style:'currency',currency:currencyCode,minimumFractionDigits:2,maximumFractionDigits:2});
    const commercialQuote = this.mwCommercialQuote();
    this.mwConfigurationQuote = commercialQuote;
    this.elems.price.dataset.mwNativeTotalCents = String(Math.round(totalPrice * 100));
    this.elems.price.dataset.mwPriceScope = commercialQuote ? 'configuration-pricebook' : 'native';
    this.elems.price.textContent = displayMoney.format(commercialQuote ? commercialQuote.totalCents / 100 : totalPrice);
    const totalPriceCompare = effectiveQuantity * (this.currentPriceCompare / 100)
    this.elems.priceCompare.textContent = commercialQuote ? '' : displayMoney.format(totalPriceCompare);
    this.elems.buyButton.innerHTML = this.elems.buyButtonText.innerHTML;
    let discountPercentage = 0;
    if (!commercialQuote && totalPriceCompare > totalPrice) {
      discountPercentage = Math.round(((totalPriceCompare - totalPrice) / totalPriceCompare) * 100);
    }
    if (commercialQuote) {
      const discountElement = document.querySelector('.discount-percentage');
      if (discountElement) discountElement.textContent = '';
    } else if (discountPercentage > 0) {
      const discountElement = document.querySelector(".discount-percentage");
      discountElement.textContent = `-${discountPercentage}%`;
    }
    console.log("totalPriceCompare yes: ", totalPriceCompare)

    this.widthInfo.textContent = `${this.elems.numberInputs[0].value}${this.measure}`;
    this.heightInfo.textContent = `${this.elems.numberInputs[1].value}${this.measure}`;

    this.updateFrameSize(this.height, this.width);
    document.dispatchEvent(new CustomEvent('mw:refresh-presentation'));
  }

  onInputNumberChange(e) {
    const max = Number(e.target.max);
    const min = Number(e.target.min);
    const val = Number(e.target.value);
    if (e.target.id === "width-inch" && e.target.value > 11) {
      this.elems.numberInputs[2].value = Number(this.elems.numberInputs[2].value) + 1;
      this.elems.numberInputs[3].value = 0;
    }
    if (e.target.id === "height-inch" && e.target.value > 11) {
      this.elems.numberInputs[4].value = Number(this.elems.numberInputs[4].value) + 1;
      this.elems.numberInputs[5].value = 0;
    }

    if (val > max) {
      e.target.value = max;
    }
    this.update();
  }

  onRadioChange(e) {
    this.measure = e.target.value;
    this.unitConverter();
    this.update();

    if (this.measure === "in") {
      this.elems.cminputs.style.display = "none";
      this.elems.ininputs.style.display = "block";
    } else if (this.measure === "cm") {
      this.elems.cminputs.style.display = "block";
      this.elems.ininputs.style.display = "none";
    }
  }

  unitConverter() {
    if (this.measure === "in") {
      const totalQuantity = Number(this.elems.quantityInput.value);
      const totalSurfaceInCm2 = totalQuantity * this.surface['cm'];

      const totalSurfaceInInches2 = totalSurfaceInCm2 * 0.155;
      this.dimensions = Math.round(totalSurfaceInInches2 * 100) / 100;

      let ratio = 1;
      let width = Math.sqrt(this.dimensions / ratio);
      let height = width * ratio;

      const maxInches = 780;

      if (width > maxInches) {
        width = maxInches;
        height = this.dimensions / maxInches;
      }

      if (height > maxInches) {
        height = maxInches;
        width = this.dimensions / maxInches;
      }

      const widthFeet = Math.floor(width / 12);
      const widthInches = Math.round(width % 12);
      const heightFeet = Math.floor(height / 12);
      const heightInches = Math.round(height % 12);

      this.elems.numberInputs[2].value = widthFeet;
      this.elems.numberInputs[3].value = widthInches;
      this.elems.numberInputs[4].value = heightFeet;
      this.elems.numberInputs[5].value = heightInches;

      this.width = width;
      this.height = height;

      this.totalQuantity = totalQuantity;
      this._syncProductSelection();
    } else if (this.measure === "cm") {
      const widthFeet = Number(this.elems.numberInputs[2].value);
      const widthInches = Number(this.elems.numberInputs[3].value);
      const heightFeet = Number(this.elems.numberInputs[4].value);
      const heightInches = Number(this.elems.numberInputs[5].value);

      const widthTotalInches = (widthFeet * 12) + widthInches;
      const heightTotalInches = (heightFeet * 12) + heightInches;

      this.width = widthTotalInches;
      this.height = heightTotalInches;

      const dimensionsInSquareFeet = (this.height * this.width) / 144;
      this.dimensions = Math.round(dimensionsInSquareFeet * 100) / 100;

      const totalSurfaceInCm2 = dimensionsInSquareFeet * 929.0304;

      let ratio = 1;
      let widthCm = Math.sqrt(totalSurfaceInCm2 / ratio);
      let heightCm = widthCm * ratio;

      this.elems.numberInputs[0].value = Math.round(widthCm);
      this.elems.numberInputs[1].value = Math.round(heightCm);

      this.width = widthCm;
      this.height = heightCm;

      this.totalQuantity = Math.ceil(totalSurfaceInCm2 / this.surface['cm']);
      this._syncProductSelection();
    }
  }

  update() {
    this.updateValues();
    this.updateUI();
    this.showLengths(false); // This will update the lengths without toggling the lines

  }

  getCompositionCrop() {
    if (!this.isReplicated && this._compositionCrop) return [...this._compositionCrop];
    if (this.isReplicated && this.selectionFrame && this.canvasProductImage) {
      return this.height>0 ? [this._repeatPhase || 0,0,this.width/this.height,1] : null;
    }
    const frame=this.selectionFrame?.getBoundingClientRect(),image=this.canvasProductImage?.getBoundingClientRect();
    return frame&&image?.width>0&&image.height>0?[(frame.left-image.left)/image.width,(frame.top-image.top)/image.height,frame.width/image.width,frame.height/image.height]:null;
  }

  setRepeatPhase(phase) {
    if (!Number.isFinite(phase)) return;
    this._repeatPhase = Math.max(0,phase);
    this.projectRepeatPhase();
    this.mwRefreshReview?.();
  }

  projectRepeatPhase() {
    if (!this.isReplicated || !this.canvasProductImage) return;
    this.canvasContainer.scrollLeft=0;
    this.canvasProductImage.style.width='100%';
    this.canvasProductImage.style.backgroundSize='auto 100%';
    this.canvasProductImage.style.backgroundPosition=`${-(this._repeatPhase || 0)*this._repeatProjectionHeight}px 0px`;
  }

  updateFrameSize(height, width) {
    console.log("moved a little bit")
    // This method updates the selection frame size and position based on the height and width

    if (this.isReplicated) {
      this.canvasContainer = this.querySelector('.canvas__container')
      let widthPixels = 0
      let heightPixels = 0
      if (this.measure === 'cm') {
        widthPixels = parseFloat(width * this.pixels.cm)
        heightPixels = parseFloat(height * this.pixels.cm)
        if (widthPixels < 45 * this.pixels.cm) {
          widthPixels = 45 * this.pixels.cm
        }
        if (heightPixels < 100 * this.pixels.cm) {
          heightPixels = 100 * this.pixels.cm
        }
      }

      if (this.measure === 'in') {
        widthPixels = parseFloat(width * this.pixels.in)
        heightPixels = parseFloat(height * this.pixels.in)

        if (widthPixels < 17.7 * this.pixels.cm) {
          widthPixels = 17.7 * this.pixels.cm
        }
        if (heightPixels < 39.3 * this.pixels.cm) {
          heightPixels = 39.3 * this.pixels.cm
        }
      }

      const aspect = widthPixels / heightPixels;
      if (!(Number.isFinite(aspect) && aspect > 0)) return;
      // CSS owns the available area. Fit both axes with one scale instead of
      // combining screen.width, imageHeight and independently clamped sizes.
      this.canvasContainer.style.height = this.imageHeight + 'px';
      this.canvasContainer.style.width = (this.imageHeight * aspect) + 'px';
      const finalHeight = Math.min(this.canvasContainer.clientHeight, this.canvasContainer.clientWidth / aspect);
      if (!(finalHeight > 0)) return;
      this.canvasContainer.style.height = finalHeight + 'px';
      this.canvasContainer.style.width = (finalHeight * aspect) + 'px';
      // A CSS pixel scroll offset is not a physical composition coordinate.
      // Keep the offset relative to the motif height when the viewport changes.
      this._repeatProjectionHeight = parseFloat(getComputedStyle(this.canvasContainer).height);
      this.projectRepeatPhase();
    } else {
      const canvasImage = this.canvasContainer.querySelector('.canvas__image');
      const canvasWidth = canvasImage.clientWidth;
      const canvasHeight = canvasImage.clientHeight;
      if (!(canvasWidth>0&&canvasHeight>0&&width>0&&height>0)) return;

      let widthPixels = 0, heightPixels = 0;

      if (this.measure === 'cm') {
        widthPixels = width * this.pixels.cm;
        heightPixels = height * this.pixels.cm;
      } else if (this.measure === 'in') {
        widthPixels = width * this.pixels.in;
        heightPixels = height * this.pixels.in;
      }

      const inputAspectRatio = widthPixels / heightPixels;
      const canvasAspectRatio = canvasWidth / canvasHeight;

      let scaledWidth, scaledHeight;

      if (inputAspectRatio > canvasAspectRatio) {
        scaledWidth = Math.min(widthPixels, canvasWidth);
        scaledHeight = scaledWidth / inputAspectRatio;
      } else {
        scaledHeight = Math.min(heightPixels, canvasHeight);
        scaledWidth = scaledHeight * inputAspectRatio;
      }

      const existingFrame = this.selectionFrame;
      const previous=this._frameProjection;
      const art=this.canvasProductImage?.style.backgroundImage||'';
      const samePhysical=previous&&previous.width===width&&previous.height===height&&previous.measure===this.measure&&previous.art===art;
      if(samePhysical&&this._compositionCrop){
        scaledWidth=this._compositionCrop[2]*canvasWidth;
        scaledHeight=this._compositionCrop[3]*canvasHeight;
      }
      const layoutKey = [width,height,canvasWidth,canvasHeight,this.measure].join(':');
      const keepPosition = this._frameLayoutKey === layoutKey;
      existingFrame.style.width = `${scaledWidth}px`;
      existingFrame.style.height = `${scaledHeight}px`;

      if(samePhysical&&this._compositionCrop){
        existingFrame.style.left=`${this._compositionCrop[0]*canvasWidth}px`;
        existingFrame.style.top=`${this._compositionCrop[1]*canvasHeight}px`;
      } else if (!keepPosition) {
        existingFrame.style.left = `${(canvasWidth - scaledWidth) / 2}px`;
        existingFrame.style.top = `${(canvasHeight - scaledHeight) / 2}px`;
      }
      this._frameLayoutKey = layoutKey;
      this._frameProjection={width,height,measure:this.measure,canvasWidth,canvasHeight,art};
      if(!samePhysical||!this._compositionCrop)this._compositionCrop=[parseFloat(existingFrame.style.left)/canvasWidth,parseFloat(existingFrame.style.top)/canvasHeight,scaledWidth/canvasWidth,scaledHeight/canvasHeight];

      this.makeFrameDraggable();
    }

  }
  async captureFrameImage(resolutionScale = 1) {
    const rasterScale = Number.isFinite(resolutionScale) ? Math.max(1, Math.min(3, resolutionScale)) : 1;
    const productCustomizer = document.querySelector('product-customizer');
    if (!productCustomizer) {
      console.error('product-customizer not found.');
      return null;
    }

    const isReplicated = productCustomizer.getAttribute('replicate-product') === 'true';
    const loadImage = (src) => {
      if (rasterScale > 1) {
        // Uploaded FileReader images already contain their bytes. Do not send
        // them through storefront fetch interceptors for a local inspection.
        if (typeof src === 'string' && src.startsWith('data:')) {
          const comma = src.indexOf(',');
          const header = src.slice(5, comma);
          if (comma < 0 || !header.endsWith(';base64')) return Promise.reject(new Error('Unsupported inspection image encoding'));
          const bytes = Uint8Array.from(atob(src.slice(comma + 1)), char => char.charCodeAt(0));
          return createImageBitmap(new Blob([bytes], { type: header.slice(0, -7) }));
        }
        return fetch(src).then(response => { if (!response.ok) throw new Error('Inspection image unavailable'); return response.blob(); }).then(blob => createImageBitmap(blob));
      }
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = (err) => reject(err);
        image.src = src;
      });
    };
    const canvasToBlob = (canvas, type = 'image/png') => {
      return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          blob ? resolve(blob) : reject(new Error('Canvas to blob conversion failed.'));
        }, type);
      });
    };

    try {
      if (!isReplicated) {
        const canvasContainer = document.querySelector('.canvas__image');
        const selectionFrame = canvasContainer?.querySelector('.selection-frame');
        const productImage = canvasContainer?.querySelector('.canvas_product_image');
        if (!canvasContainer || !selectionFrame || !productImage) {
          console.error("Required elements not found.");
          return null;
        }
        const viewRect = node => { const r=node.getBoundingClientRect(),s=this.scale||1; return {left:r.left/s,top:r.top/s,width:r.width/s,height:r.height/s}; };
        const imageRect = viewRect(productImage);
        imageRect.width=parseFloat(getComputedStyle(productImage).width);
        imageRect.height=parseFloat(getComputedStyle(productImage).height);
        const frameRect = viewRect(selectionFrame);
        const crop=this.getCompositionCrop();
        const x = crop?crop[0]*imageRect.width:frameRect.left-imageRect.left;
        const y = crop?crop[1]*imageRect.height:frameRect.top-imageRect.top;
        const width = crop?crop[2]*imageRect.width:frameRect.width;
        const height = crop?crop[3]*imageRect.height:frameRect.height;
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = width * rasterScale;
        tempCanvas.height = height * rasterScale;
        const ctx = tempCanvas.getContext('2d');
        ctx.scale(rasterScale, rasterScale);
        const bgUrl = getComputedStyle(productImage).backgroundImage.slice(5, -2);
        const image = await loadImage(bgUrl);
        const imageStyle=getComputedStyle(productImage);
        const coverScale=Math.max(imageRect.width/image.width,imageRect.height/image.height);
        const containScale=Math.min(imageRect.width/image.width,imageRect.height/image.height);
        const backgroundScale=imageStyle.backgroundSize==='cover'?coverScale:imageStyle.backgroundSize==='contain'?containScale:null;
        const drawnWidth=backgroundScale===null?imageRect.width:image.width*backgroundScale;
        const drawnHeight=backgroundScale===null?imageRect.height:image.height*backgroundScale;
        const position=imageStyle.backgroundPosition.split(' ');
        const positionOffset=(value,available)=>value.endsWith('%')?available*parseFloat(value)/100:parseFloat(value)||0;
        const imageX=positionOffset(position[0],imageRect.width-drawnWidth),imageY=positionOffset(position[1]||position[0],imageRect.height-drawnHeight);
        ctx.filter = getComputedStyle(this.canvasContainer).filter;
        if (this.flip) {
          ctx.translate(imageRect.width-x,-y);ctx.scale(-1,1);
          ctx.drawImage(image,imageX,imageY,drawnWidth,drawnHeight);
        } else ctx.drawImage(image,imageX-x,imageY-y,drawnWidth,drawnHeight);
        image.close?.();
        return await canvasToBlob(tempCanvas, 'image/png');
      } else {
        const containerEl = document.querySelector('.canvas__container');
        const backgroundEl = document.querySelector('.canvas_product_image');
        if (!containerEl || !backgroundEl) {
          console.error('Missing .canvas__container or .canvas_product_image');
          return null;
        }
        const viewRect = node => { const r=node.getBoundingClientRect(),s=this.scale||1; return {left:r.left/s,top:r.top/s,width:r.width/s,height:r.height/s}; };
        const containerRect = viewRect(containerEl), frameRect=viewRect(this.selectionFrame);
        const desiredWidth = Math.round(frameRect.width);
        const desiredHeight = Math.round(frameRect.height);
        if (desiredWidth <= 0 || desiredHeight <= 0) {
          console.error('Container has zero or negative dimensions');
          return null;
        }
        let bgUrl = getComputedStyle(backgroundEl).getPropertyValue('background-image');
        bgUrl = bgUrl?.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
        if (!bgUrl) {
          console.error('No valid background-image found');
          return null;
        }
        const offscreenCanvas = document.createElement('canvas');
        offscreenCanvas.width = desiredWidth * rasterScale;
        offscreenCanvas.height = desiredHeight * rasterScale;
        const ctx = offscreenCanvas.getContext('2d');
        ctx.scale(rasterScale, rasterScale);
        const backgroundImage = await loadImage(bgUrl);
        const imgWidth = backgroundImage.width;
        const imgHeight = backgroundImage.height;
        const scale = containerRect.height / imgHeight;
        const scaledWidth = imgWidth * scale;
        const scaledHeight = containerRect.height;
        ctx.filter=getComputedStyle(this.canvasContainer).filter;
        const offsetX=frameRect.left-containerRect.left,offsetY=frameRect.top-containerRect.top;
        const flipped=this.flip;
        const origin = (this._repeatPhase || 0)*containerRect.height;
        if(flipped){ctx.translate(containerRect.width-offsetX,-offsetY);ctx.scale(-1,1);}else ctx.translate(-offsetX,-offsetY);
        ctx.translate(-origin,0);
        const firstTile = Math.floor(origin / scaledWidth) * scaledWidth;
        const lastTile = origin+containerRect.width+scaledWidth;
        for (let x = firstTile; x < lastTile; x += scaledWidth) {
          ctx.drawImage(backgroundImage, x, 0, scaledWidth, scaledHeight);
        }
        backgroundImage.close?.();
        return await canvasToBlob(offscreenCanvas, 'image/png');
      }
    } catch (error) {
      console.error('Error capturing frame image:', error);
      return null;
    }
  }

  makeFrameDraggable() {
    console.log("mkaeFrameDraggable is scrolling")
    const frame = this.selectionFrame;

    if (this._dragFrame === frame && this._frameDragCleanup) {
      return;
    }

    this._frameDragCleanup?.();

    let isDragging = false;
    let startX = 0;
    let startY = 0;

    const startDragging = (e) => {
      isDragging = true;
      startX = (e.touches ? e.touches[0].clientX : e.clientX) / (this.scale || 1) - frame.offsetLeft;
      startY = (e.touches ? e.touches[0].clientY : e.clientY) / (this.scale || 1) - frame.offsetTop;
      frame.style.cursor = 'move';
      e.preventDefault();
    };

    const doDrag = (e) => {
      if (!isDragging) return;

      const currentX = (e.touches ? e.touches[0].clientX : e.clientX);
      const currentY = (e.touches ? e.touches[0].clientY : e.clientY);

      const newX = currentX / (this.scale || 1) - startX;
      const newY = currentY / (this.scale || 1) - startY;

      const maxX = this.canvasContainer.clientWidth - frame.offsetWidth;
      const maxY = this.canvasContainer.clientHeight - frame.offsetHeight;

      frame.style.left = `${Math.min(Math.max(newX, 0), maxX)}px`;
      frame.style.top = `${Math.min(Math.max(newY, 0), maxY)}px`;
      const image=this.canvasContainer.querySelector('.canvas__image');
      if(!this.isReplicated&&image?.clientWidth>0&&image.clientHeight>0){this._compositionCrop=[parseFloat(frame.style.left)/image.clientWidth,parseFloat(frame.style.top)/image.clientHeight,parseFloat(frame.style.width)/image.clientWidth,parseFloat(frame.style.height)/image.clientHeight];}
    };

    const stopDragging = () => {
      isDragging = false;
      frame.style.cursor = 'default';
    };

    frame.addEventListener('mousedown', startDragging);
    document.addEventListener('mousemove', doDrag);
    document.addEventListener('mouseup', stopDragging);

    frame.addEventListener('touchstart', startDragging);
    document.addEventListener('touchmove', doDrag);
    document.addEventListener('touchend', stopDragging);

    this._dragFrame = frame;
    this._frameDragCleanup = () => {
      frame.removeEventListener('mousedown', startDragging);
      document.removeEventListener('mousemove', doDrag);
      document.removeEventListener('mouseup', stopDragging);
      frame.removeEventListener('touchstart', startDragging);
      document.removeEventListener('touchmove', doDrag);
      document.removeEventListener('touchend', stopDragging);
      this._dragFrame = null;
      this._frameDragCleanup = null;
    };
  }


  zoom(scaleChange) {
    if(this.mwSetViewZoom){this.mwSetViewZoom((this.mwViewZoom||1)+scaleChange);return;}
    console.log("scale change: ", scaleChange + " this.scale: ", this.scale);

    // Apply the scale change
    this.scale += scaleChange;

    // Ensure that the scale does not go below 1
    if (this.scale < (this.mwViewMinScale ?? 1)) {
      this.scale = this.mwViewMinScale ?? 1;
      console.log("reached the limit, scale set to 1");
    }

    // Cap the maximum scale at 2
    if (this.scale > (this.mwViewMaxScale ?? 2)) {
      this.scale = this.mwViewMaxScale ?? 2;
    }

    // Apply the scale transformation
    this.canvasContainer.style.transform = `scale(${this.scale})`;
    this.canvasContainer.style.transformOrigin = 'center center';
    this.canvasProductImage.style.transformOrigin = 'center';
  }

  zoomIn() {
    this.zoom(0.1);  // Zoom in by 10%
  }

  zoomOut() {
    this.zoom(-0.1);  // Zoom out by 10%
  }


  calculateMaxSizes() {
    if (screen.width < 820) {
      this.maxWidth = screen.width;
      this.maxHeight = screen.width;
    } else {
      this.maxWidth = 820;
      this.maxHeight = 410;
    }
    this.imageHeight = 410;
  }

  greyScaleImage() {
    this.greyScale = !this.greyScale;
    this.greyscaleInput.value = this.greyScale;
    if (this.greyScale) {
      this.elems.greyScale.classList.add('active');
      this.canvasContainer.style.filter = 'grayscale(1)';
    }

    if (!this.greyScale) {
      this.elems.greyScale.classList.remove('active');
      this.canvasContainer.style.filter = 'grayscale(0)';
    }
  }

  flipImage() {
    this.flip = !this.flip;

    if (this.flip) {
      this.elems.flip.classList.add('active');
      this.canvasProductImage.style.transform = 'scaleX(-1)';
    }

    if (!this.flip) {
      this.elems.flip.classList.remove('active');
      this.canvasProductImage.style.transform = 'scaleX(1)';
    }
  }

  showLengths(toggle = true) {
    // Only toggle `this.verticalLines` if `toggle` is true (i.e., no parameter or true is passed)
    if (toggle) {
      this.verticalLines = !this.verticalLines;
    }

    // Ensure `selectionFrame` is available
    if (!this.selectionFrame) {
      console.error('Selection frame not found');
      return;
    }

    // Clear any existing lines (both vertical lines and grid)
    this.selectionFrame.innerHTML = '';

    // If vertical lines are toggled on
    if (this.verticalLines) {
      this.elems.length.classList.add('active');

      const selectionFrameWidth = this.selectionFrame.clientWidth; // Get the width of the selection frame
      const selectedWidth = Number(document.getElementById('width').value); // Get the selected width in cm

      if (!selectedWidth || selectedWidth <= 0) {
        console.error('Invalid width selected.');
        return;
      }

      // Set the interval for the lines (e.g., every 50cm)
      const interval = 50;
      const numLines = Math.floor(selectedWidth / interval); // Calculate how many lines we need

      // Calculate the spacing between lines in the frame based on the width selected
      const sectionWidth = selectionFrameWidth / selectedWidth * interval;

      // Add vertical lines based on the width selected and interval
      for (let i = 1; i <= numLines; i++) {
        const line = document.createElement('div');
        line.classList.add('length-line');

        // Set the style for the vertical line
        line.style.position = 'absolute';
        line.style.left = `${i * sectionWidth}px`; // Position the line at the correct division
        line.style.top = '0';
        line.style.height = '100%';
        line.style.width = '1px';
        line.style.backgroundColor = 'black'; // Line color
        line.style.zIndex = '20'; // Ensure the line is on top of the selection frame content

        // Append the line to the selection frame
        this.selectionFrame.appendChild(line);
      }

    } else {
      // Add the default grid back when vertical lines are turned off
      this.elems.length.classList.remove('active');

      // Create grid cells (3x3 grid)
      for (let row = 0; row < 3; row++) {
        for (let col = 0; col < 3; col++) {
          const gridCell = document.createElement('div');
          gridCell.classList.add('grid-cell'); // Add a class for each grid cell

          // Set the style for the grid cell
          gridCell.style.border = '1px dashed black'; // Dashed grid lines
          gridCell.style.gridRowStart = row + 1;
          gridCell.style.gridColumnStart = col + 1;

          // Append the grid cell to the selection frame
          this.selectionFrame.appendChild(gridCell);
        }
      }
    }
  }






}
customElements.define('product-customizer', ProductCustomizer);
